import { useMemo } from 'react';
import { useParams } from '@/providers/RouterShim';
import useBranch from '../../data/branch/useBranch';
import useBranches from '../../data/branch/useBranches';
import usePermissions from '../../data/permissions/usePermissions';
import useAuth from '../../hooks/useAuth';
import { isWrongMarket } from './WrongMarket';

const useInitialized = () => {
  const { decodedToken } = useAuth();
  const { branchId } = useParams();
  const [_, requestBranch] = useBranch();
  const [branches, requestBranches] = useBranches();
  const [___, requestPermissions] = usePermissions();

  const loading =
    requestBranch.isLoading || requestBranches.isLoading || requestPermissions.isLoading;

  const errorType = useMemo(() => {
    if (isWrongMarket(decodedToken)) return 'wrong-market';
    if (!decodedToken?.['belongs-to-branch']?.length) return 'empty-branch-list';
    if (requestBranches.isError) return 'branches';
    if (requestBranch.isError) return 'branch';
    if (requestPermissions.isError) return 'permissions';
    if (requestBranch.isSuccess && !branches?.find((x) => x.id === branchId))
      return 'unknown-branch';

    return undefined;
  }, [
    requestBranch.isSuccess,
    requestBranch.isError,
    requestBranches.isError,
    requestPermissions.isError,
    decodedToken,
    branches,
  ]);

  const initialized = !loading && !errorType;

  return {
    loading,
    errorType,
    initialized,
  };
};

export default useInitialized;
